import api from '../api/apiClient'
import type { Transaction, TransactionFilters, TransactionListResponse } from '../models/transaction'

export const transactionsRepository = {
  getAll: async (filters?: TransactionFilters): Promise<TransactionListResponse> => {
    const params = new URLSearchParams()
    if (filters?.limit) params.append('limit', filters.limit.toString())
    if (filters?.status) params.append('status', filters.status)
    if (filters?.type) params.append('type', filters.type)
    
    const response = await api.get(`/transactions/all?${params.toString()}`)
    return response.data
  },

  getById: async (id: number): Promise<Transaction> => {
    const response = await api.get(`/transactions/${id}`)
    return response.data.data
  }
}